import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
  UrlMatchResult,
  UrlSegment
} from '@angular/router';

import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { MemberLayoutComponent } from './layouts/member-layout/member-layout.component';

import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { DashboardComponent } from './views/member/dashboard/dashboard.component';

import { authGuard } from './core/auth/auth-guard';
import { ProjectCreateComponent } from './views/member/createproject/project-create';
import { ProjectListComponent } from './views/member/projectlist/projectlist.component';
import { Settings } from './views/member/settings/settings';
import { Userprofile } from './views/member/userprofile/userprofile';
import { MarketComponent } from './views/market/market.component';
import { MarketLayoutComponent } from './layouts/market-layout/market-layout.component';
import { ApplicationProfileComponent } from './views/application-profile/application-profile.component';
import { MarketPlaceComponent } from './views/member/marketplace/marketplace.component';
import { ProjectInfo } from './views/member/project-info/project-info';
import { ProjectRun } from './views/member/project-run/project-run';

const routes: Routes = [

   // GUEST HOME LAYOUT
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
 
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
      matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
        if (segments.length !== 1) return null;

        const match = segments[0].path.match(/^(.+)-a(\d+)$/);
        if (!match) return null;

        return {
            consumed: segments,
            posParams: {
                slug: new UrlSegment(match[1], {}),
                pid: new UrlSegment(match[2], {})
            }
        };
    },
      component: ApplicationProfileComponent
      }
      
    ]
  },

    {
    path: 'market',
    component: MarketComponent,
    },
   




  // MEMBERS LAYOUT
  
      {
    path: '',
    component: MemberLayoutComponent,
    // canActivate: [authGuard],
    children: [
           {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'marketplace',
        component: MarketPlaceComponent
      },
       {
      path: 'application/:id',
        component: ApplicationProfileComponent
      },
      {
        path: 'run/:id',
        component: ProjectRun
      },
      {
        path: 'createproject',
        component: ProjectCreateComponent
      },
      {
        path: 'project/:id',
        component: ProjectInfo
      },
       {
        path: 'projectlist',
        component: ProjectListComponent
      },
        {
        path: 'settings',
        component: Settings
      },

    {
        path: 'userprofile',
        component: Userprofile
      },
    ]
  },


  // Bulunamayan adresleri anasayfaya yönlendir
  {
    path: '**',
    redirectTo: ''
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
